// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".review .separator{border-bottom:1px solid #e0edff;margin:2% 0}@media print{.review .human-skills{padding:0}.review .review-item{padding-top:0 !important}.review .row{padding-top:0}}\n", ""]);
// Exports
module.exports = exports;
